<template>
  <div id="service">
    <div class="header">
      <van-search
        disabled
        v-model="searchValue"
        placeholder="搜索关键词"
        @click="searchTap"
      />
      <div class="tab-wrap">
        <div
          class="tab"
          :class="{ 'tab-active': tabActive == i }"
          v-for="(item, i) in tabs"
          :key="i"
          @click="tabTap(i)"
        >
          {{ item }}
        </div>
      </div>
    </div>
    <components :is="comps[tabActive]"></components>
  </div>
</template>
<script>
import expert from './components/expert' // 专家智库
import quotation from './components/quotation' // 产业行情
import cydata from './components/cydata' // 行业数据
import warning from './components/warning' // 商务预警
import report from './components/report' // 行业报告
import { getToken } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { getLocalStorage } from '@utils'
export default {
  components: {
    expert,
    quotation,
    cydata,
    warning,
    report
  },
  data() {
    return {
      searchValue: '',
      tabs: ['产业行情', '行业数据', '行业报告', '商务预警', '专家智库'],
      tabActive: '',
      comps: ['quotation', 'cydata', 'report', 'warning', 'expert'],
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  created() {
    if (getToken()) {
      this.tabActive = 0
    }
  },
  methods: {
    searchTap() {
      this.$router.push({
        path: '/servicebus/search'
      })
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    tabTap(i) {
      this.buriedPoint()
      this.tabActive = i
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  width: 100%;
  height: 4.2rem;
  background: url('~@assets/images/news.png') no-repeat;
  background-size: 100% 100%;
  position: sticky;
  top: 0;
  z-index: 10;
}
.van-search {
  padding: 1.9rem 0.4rem 0.1rem;
  z-index: 10;
  background: transparent;
  .van-search__content {
    border-radius: 20px;
    background: rgba(247, 248, 250, 0.8);
  }
  /deep/.van-cell__value {
    padding: 0 4px;
  }
  /deep/.van-field__control:disabled {
    -webkit-text-fill-color: #666 !important;
  }
}
.tab-wrap {
  display: flex;
  align-items: center;
  margin-top: 0.2rem;
  .tab {
    flex: 1;
    font-size: 14px;
    text-align: center;
    height: 32px;
    line-height: 26px;
    color: rgba(255, 255, 255, 0.75);
    transition: 0.2s;
  }
  .tab-active {
    color: #fff;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>
